$(function() {

    /* ----------------------------------------- DATA-BG INCLUI IMAGEM NA TAG HTML DO BANNER -- */
    $('.banner-item').each(function(){
        var imgBanner = $(this).data('banner');
        $(this).css('background-image', 'url('+imgBanner+')');
    });
    $('.banner-wrapper').each(function() {
        var animation = $(this).data('animation');
        $(this).css('animation-name', animation)
    })

    /* ----------------------------------------- PÁGINA PRODUTO -- */

    // Mostra o modal ao clicar no botão "mais"
    $('#show-all-btn').on('click', function() {
        $('#modal_validation').modal('show');
    });


    /* ----------------------------------------------- BLOQUEIA LINKS QUE NÃO POSSUEM DIRECIONAMENTO -- */
    $('.main-nav-links li a, .main-utility-links-wrapper a').on('click', function(e) {
        var link = $(this).attr('href');
        if(link == '#' || link == ''){
            e.preventDefault();
        };
    });


    /* ----------------------------------------------- MOSTRA/OCULTA A ÁREA DE PESQUISA -- */
    $('.search-open').on('click', function(){
        $('.search-wrapper').css('height', '50px');
    });
    $('.search-close').on('click', function(){
        $('.search-wrapper').css('height', '0px');
        $('.search-input-wrapper input').val('');
    });



    /* ----------------------------------------------- IMPEDE PESQUISA VAZIA -- */
    $('.search-form').on('input', function() {
        if( $('.search-form').hasClass('empty') ) {
            $('.search-form').removeClass('empty')
        }
        if($(this).val().length === 0) {
            $(this).attr('placeholder', 'Pequise aqui');
        }
    });

    /* --------------------------------------------- MOSTRA/ESCONDE SENHAS DIGITADAS -- */
    window.addSenhaEvents = function(selector){
        $(selector).on('keypress paste change', function(){
            var senha = $(this).val().replace(/\.|\-|\//g, '');
            $(this).val(senha);
            $(this).next().removeClass('d-none');
        });
        $(selector).on('blur', function() {
            if($(this).val() == ''){
                $(this).next().attr('class', 'fas fa-eye d-none');
                $(this).attr('type', 'password');
            }
        });
        $(selector).next().on('click', function(e){
            if(e.target.className == 'fas fa-eye') {
                $(this).attr('class', 'fas fa-eye-slash');
                $(this).prev().attr('type', 'text');
            } else {
                $(this).attr('class', 'fas fa-eye');
                $(this).prev().attr('type', 'password');
            }
        });
    }

    var selector = "input[type='password']";
    addSenhaEvents(selector);

/* --------------------------------------------- HABILITA ENVIO DO ORÇAMENTO --------------------------------------------- */
    $('input[type=checkbox]').on('change', function () {
        const $form = $(this).closest('form');

        // Ativa ou desativa o fieldset dentro do mesmo form
        $form.find('fieldset').prop('disabled', !this.checked);

        // Se tiver área de recaptcha, mostra/esconde junto
        const $recaptcha = $form.find('.recaptcha');
        if ($recaptcha.length) {
            if (this.checked) $recaptcha.removeClass('d-none');
            else $recaptcha.addClass('d-none');
        }
    });




    /* --------------------------------------------- ALERT -- */
    window.exibirMensagem  = function(seletor, tipo, mensagem) {
        const alerta = $(
            `<div class="alert alert-${tipo} w-100 text-center m-0">
                ${mensagem}
            </div>`
        );

        $(seletor).html(alerta);

        setTimeout(() => {
            alerta.fadeOut('slow', function () {
                $(this).remove();
            });
        }, 4800);
    };
    setTimeout(() => {
        $('.alert-render-php').fadeOut('slow', function () {
            $(this).remove();
        });
    }, 2800);


    document.addEventListener("DOMContentLoaded", function() {
        var elem = document.querySelector('.grid');

        var msnry = new Masonry(elem, {
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        percentPosition: true
        });

        imagesLoaded(elem, function() {
        msnry.layout();
        });
    });

});



//------------------------------------------------------  Produto mini thumbs check
$('.mini-thumbs-wrapper label').on('mouseenter', function () {
    const radioId = $(this).attr('for');

    if (radioId) {
        $('#' + radioId).prop('checked', true).trigger('change');

        const index = $('.mini-thumbs-wrapper label').index(this);

        $('.main-thumb .swiper-slide').hide();

        const $targetSlide = $('.main-thumb .swiper-slide').eq(index);
        $targetSlide.show();

        $('.main-thumb .swiper-slide img').attr('aria-hidden', 'true');
        $targetSlide.find('img').attr('aria-hidden', 'false');
    }
});


//------------------------------------------------------  Mudar cor do produto
$(function () {
    $('.color-circle').on('click', function () {
        const imgSrc = $(this).data('img');

        $('.main-thumb .thumb-img-on').attr('src', imgSrc);

        $('.color-circle').removeAttr('aria-current');
        $(this).attr('aria-current', 'true');
    });
});


//------------------------------------------------------  Mudar posição do dropdown de categorias
requestAnimationFrame(() => {
  function positionDropdown() {
    const navbar = document.querySelector('.navbar');
    const dropdown = document.querySelector('#dropdownCat');

    if (navbar && dropdown) {
      const navbarBottom = navbar.getBoundingClientRect().bottom;
      dropdown.style.top = navbarBottom + 'px';
    }
  }

  $('#openMenu').on('click', positionDropdown);
  $(window).on('resize', positionDropdown);
});

$(document).on('click', function (e) {
  if (!$(e.target).closest('.dropdown-ignore').length) {
    $('#dropdownCat').removeClass('show');
  }
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.submenu-toggle').forEach(toggle => {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation(); // ⛔️ impede que o clique feche o dropdown principal

      const submenu = this.nextElementSibling;

      // Fecha outros submenus
      document.querySelectorAll('.dropdown-submenu .dropdown-menu.show')
        .forEach(open => {
          if (open !== submenu) open.classList.remove('show');
        });

      submenu?.classList.toggle('show');
    });
  });
});


//------------------------------------------------------ Check all in permitions admin
let allChecked = false;

$('#checkPermissao').on('click', function () {
    allChecked = !allChecked;
    $('input[type="checkbox"][name="itens[]"]').prop('checked', allChecked);
    $(this).text(allChecked ? 'Desmarcar Todos' : 'Selecionar Todos');
});

//------------------------------------------------------ Searchbar Mobile
document.addEventListener('DOMContentLoaded', () => {
  const btn = document.getElementById('searchButton');
  const box = document.getElementById('searchBox');
  let flag = true;

  function openSearch() {
    if (!box) return; // /admin não tem searchBox
    box.style.WebkitTransform = flag ? "translate(0px, 2%)" : "";
    box.style.msTransform = flag ? "translate(0px, 2%)" : "";
    box.style.transform = flag ? "translate(0px, 2%)" : "";
    box.style.transition = "all 0.4s ease";
    flag = !flag;
  }

  if (btn && box) {
    btn.addEventListener("click", openSearch);
  }
});
